import {mapActions, mapMutations, mapState} from "ui.vue3.vuex";

export const SectionsElements = {
    data(): object {
        return {
            itemSectionList: [
                {
                    thumb: "/local/templates/academy/img/example/methodological/sections/thumbs/thumb-1.jpg",
                    logo: "/local/templates/academy/img/example/methodological/sections/logos/logo-1.png",
                    name: "Кванториумы",
                    slug: "Кванториумы",
                },
                {
                    thumb: "/local/templates/academy/img/example/methodological/sections/thumbs/thumb-2.jpg",
                    logo: "/local/templates/academy/img/example/methodological/sections/logos/logo-2.png",
                    name: "IT-кубы",
                    slug: "IT-кубы",
                },
                {
                    thumb: "/local/templates/academy/img/example/methodological/sections/thumbs/thumb-3.jpg",
                    logo: "/local/templates/academy/img/example/methodological/sections/logos/logo-3.png",
                    name: "Точки роста\n          и школьные\n          лаборатории",
                    slug: "Точки роста и школьные лаборатории",
                },
                {
                    thumb: "/local/templates/academy/img/example/methodological/sections/thumbs/thumb-4.jpg",
                    logo: "/local/templates/academy/img/example/methodological/sections/logos/logo-4.png",
                    name: "Психолого-педагогические\n          классы",
                    slug: "Психолого-педагогические классы",
                },
                {
                    thumb: "/local/templates/academy/img/example/methodological/sections/thumbs/thumb-5.jpg",
                    logo: "/local/templates/academy/img/example/methodological/sections/logos/logo-5.svg",
                    name: "Воспитательные\n          практики",
                    slug: "Воспитательные практики",
                },
                {
                    thumb: "/local/templates/academy/img/example/methodological/sections/thumbs/thumb-6.jpg",
                    logo: "/local/templates/academy/img/example/methodological/sections/logos/logo-6.svg",
                    name: "Диалог <br>с&nbsp;родителями",
                    slug: "Диалог с родителями",
                },
                {
                    thumb: "/local/templates/academy/img/example/methodological/sections/thumbs/thumb-7.jpg",
                    logo: "/local/templates/academy/img/example/methodological/sections/logos/logo-7.png",
                    name: "Образовательный\n          контент по предметам",
                    slug: "Образовательный контент по предметам",
                },
                {
                    thumb: "/local/templates/academy/img/example/methodological/sections/thumbs/thumb-8.jpg",
                    logo: "/local/templates/academy/img/example/methodological/sections/logos/logo-8.svg",
                    name: "Дополнительное\n          образование детей",
                    slug: "Дополнительное образование детей",
                },
                {
                    thumb: "/local/templates/academy/img/example/methodological/sections/thumbs/thumb-9.jpg",
                    logo: "/local/templates/academy/img/example/methodological/sections/logos/logo-9.svg",
                    name: "Справочник\n          научно-методических\n          разработок",
                    slug: "Справочник научно-методических разработок",
                },
            ]
        }
    },
    computed: {
        ...mapState('filtersStore', ['filterItems']),
    },
    methods: {
        ...mapActions('filtersStore', ['sendFilters']),
        ...mapMutations('filtersStore', ['setDefaultData', 'setElement']),
        sendSection(section) {
            let rubrics = this.filterItems.filter(item => item.slug === "rubrics")
            let rubric = rubrics[0].options.filter(item => item.label === section);
            this.setDefaultData();
            this.setElement({name: 'rubric_id', value: rubric[0].id});
            this.sendFilters();
        }
    },
    template: `
        <a href="#section-methodological-items" @click="sendSection(section.slug)" v-for="section in itemSectionList" class="methodological-section methodological-sections__element">
          <img :src="section.thumb"
               :alt="section.name"
               class="img-absolute methodological-section__thumb">
          <img :src="section.logo"
               :alt="section.name"
               class="methodological-section__logo">
          <div class="methodological-section__title">
            <h3 v-html="section.name"></h3>
          </div>
        </a>
`
}